module.exports = __webpack_public_path__ + "img/08—01—03—Diagnostic information > WLAN Expanded.0473bd29.jpg";